import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';

import { useAppDispatch } from 'store';
import { setHeaderTitle } from 'widgets/Header';
import { MainSearchFormV2 } from 'features/search';
import { ExpiredPlanModal, useIsExpired, useIsUnverified } from 'features/auth';

export const Search = () => {
	const dispatch = useAppDispatch();
	const isExpired = useIsExpired();
	const isUnverified = useIsUnverified();

	useEffect(() => {
		dispatch(setHeaderTitle(''));
	}, [dispatch]);

	if (isUnverified) return <Navigate to="/finish-verification" />;

	return (
		<>
			<MainSearchFormV2 />
			{isExpired && <ExpiredPlanModal />}
		</>
	);
};
